// components/EditInverterModal.js
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import { fetchData } from "../helper/api.interceptor";

const EditInverterModal = ({ show, onClose, editData, refreshList }) => {
    const [formData, setFormData] = useState({
        name: "",
        capacityWatt: "",
        type: "",
        price: "",
        description: "",
        image: null,
    });
    useEffect(() => {
        console.log("EDIT DATA:", editData); // Add this
        if (editData) {
            setFormData({
                name: editData.name || "",
                capacityWatt: (editData.capacity || "").replace(/\D/g, ""),
                type: editData.type || "",
                price: (editData.price || "").replace(/[^\d]/g, ""),
                description: editData.description || "",
                image: null,
            });
        } else {
            setFormData({
                name: "",
                capacityWatt: "",
                type: "",
                price: "",
                description: "",
                image: null,
            });
        }
    }, [editData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageChange = (e) => {
        setFormData((prev) => ({ ...prev, image: e.target.files[0] }));
    };

    const handleSubmit = async () => {
        const payload = new FormData();
        payload.append("name", formData.name);
        payload.append("capacityWatt", formData.capacityWatt);
        payload.append("type", formData.type);
        payload.append("price", formData.price);
        payload.append("description", formData.description);
        if (formData.image) {
            payload.append("image", formData.image);
        }

        try {
            if (editData) {
                await fetchData.post(`/inverter/update?id=${editData.id}`, payload);
                Swal.fire("Updated!", "Inverter updated successfully", "success");
            } else {
                await fetchData.post(`/inverter/add`, payload);
                Swal.fire("Added!", "Inverter added successfully", "success");
            }
            onClose();
            refreshList();
        } catch (err) {
            Swal.fire("Error", "Something went wrong", "error");
        }
    };

    if (!show) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {editData ? "Edit Inverter" : "Add Inverter"}
                        </h5>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={onClose}
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Name</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="name"
                                    value={formData.name}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label">Capacity (Watt) *</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="capacityWatt"
                                    value={formData.capacityWatt || ""}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Type</label>
                                <div className="toggle-group">
                                    {["Hybrid", "Grid-tied", "Off-grid"].map((t) => (
                                        <button
                                            type="button"
                                            key={t}
                                            className={`toggle-btn ${formData.type === t ? "active" : ""}`}
                                            onClick={() =>
                                                setFormData((prev) => ({ ...prev, type: t }))
                                            }
                                        >
                                            {t}
                                        </button>
                                    ))}
                                </div>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label className="form-label">Price</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="price"
                                    value={formData.price}
                                    onChange={(e) => {
                                        const numericValue = e.target.value.replace(/\D/g, ""); // allow only digits
                                        setFormData((prev) => ({ ...prev, price: numericValue }));
                                    }}
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                />
                            </div>
                            <div className="col-md-12 mb-3">
                                <label className="form-label">Image</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    onChange={handleImageChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button className="btn btn-primary" onClick={handleSubmit}>
                            {editData ? "Update" : "Add"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EditInverterModal;
